<template>

    <Layout>
      <Card>
        <p slot="title">团队管理</p>

        <div class="content">
        <el-table :data="tableData" >
          <el-table-column prop="id" align="center" minWidth="120" label="ID"></el-table-column>
          <el-table-column prop="teamName" align="center" minWidth="120"  label="团队姓名"></el-table-column>
          <el-table-column prop="description" align="center" minWidth="150"  label="描述"></el-table-column>
          <el-table-column prop="teamType" align="center" minWidth="150"  label="团队类型"></el-table-column>
          <el-table-column prop="createTime" align="center" minWidth="120"  label="创建日期"></el-table-column>

        </el-table>
        <el-pagination
          :current-page="pagenum"
          :total="total"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      </Card>
      
      <clientListDialog @close="clientListDialogClose" :visible="clientList.visible" :doctorId="clientList.doctorId"/>
      <changeBindDialog @close="changeBindDialogClose" :doctor="changeDoctor" :visible="changeBind.visible"/>
      <dismissDialog :teamLabel="team.label" @close="dismissDialogClose" @confirm="dismissDialogConfirm" :visible="dismiss.visible"/>
      <dismissConfirmDialog @close="dismissDialogConfirmClose" :userId="dismiss.userId" @confirm="dismissDialogConfirmConfirm" :visible="dismissConfirm.visible"/>
      <basicInfo @close="basicInfoClose" :editAble="false" :userId="basicInfo.userId" :visible="basicInfo.visible"/>
      <messageDialog @close="messageDialogClose" :visible="message.visible" :doctorId="message.doctorId"/>
      
    </Layout>
</template>
<script>

import clientListDialog from "./clientListDialog.vue";
import changeBindDialog from "./changeBindDialog.vue";
import dismissDialog from "./dismissDialog.vue";
import dismissConfirmDialog from "./dismissConfirmDialog.vue";
import basicInfo from "../userInfo/basicInfo.vue";
import messageDialog from "./messageDialog.vue";

export default {

  components: {
   clientListDialog,
   changeBindDialog,
   dismissDialog,
   dismissConfirmDialog,
   basicInfo,
   messageDialog,

  },
  data() {
    return {
      total: 10,
      pagenum: 1,
      status,
      pagesize: 10,
      input: "",
      tableData:[],
//      tableData: [{
//    "id": 1,
//    "name": "探美族健管师团队",
//    "mobile": "0020-88888888",
//    "sex": "中华区域总代理",
//    "birth": "中卫健抗衰老医生集团",
//    "avatar": "",
//    "status": 1
//},{
//    "id": 1,
//    "name": "昕光亮咨询师团队",
//    "mobile": "0020-88888888",
//    "sex": "中华区域总代理",
//    "birth": "中卫健抗衰老医生集团",
//    "avatar": "",
//    "status": 1
//},{
//    "id": 1,
//    "name": "中卫健健管师团队",
//    "mobile": "0020-88888888",
//    "sex": "中卫健健管师团队",
//    "birth": "中卫健抗衰老医生集团",
//    "avatar": "",
//    "status": 1
//}],
      actionColumns:[],
      changeDoctor:null,
      team:{
       label:''
      },
      clientList:{
        visible:false,
        doctorId:null,
      },
      changeBind:{
       visible:false,
      },
      dismiss:{
       visible:false,
       userId:null
      },
      dismissConfirm:{
       visible:false,
      },
      basicInfo:{
       visible:false,
       userId:null,
      },
      message:{
        visible:false,
        doctorId:null,
      },

    };
  },
  mounted(){

    if(this.user.isTDD())
    {
      this.team.label=this.user.doctorTypeE.TDD;
    }
    else if(this.user.isJGD())
    {
      this.team.label=this.user.doctorTypeE.JGD;
    }else if(this.user.isZXS())
    {
      this.team.label=this.user.doctorTypeE.ZXS;
    }
    else
    {
      this.team.label=this.user.doctorTypeE.XTGLY;
    }
  },
  created() {

    var that=this;
    that.init();
    that.loadData();

  },
  methods: {
    init(){

    },

    handleClose: function () {
      this.$emit('close');
    },
    messageDialogClose(){
      this.message.visible=false;
      this.message.doctorId=null;
    },
    showBasicInfo(row){
      this.basicInfo.visible=true;
      this.basicInfo.userId=row.id;
    },
    basicInfoClose(){
      this.basicInfo.userId=null;
      this.basicInfo.visible=false;
    },
    changeBindShow(row){
      this.changeDoctor=row;
      this.changeBind.visible=true;
    },
    clientListShow(row){
      this.clientList.doctorId=row.id;
      this.clientList.visible=true;
    },
    clientListDialogClose(){
      this.clientList.doctorId=null;
      this.clientList.visible=false;
    },
    changeBindDialogClose(){
      this.changeBind.visible=false;
    },
    doDismiss(row){
      this.dismiss.userId=row.id;
      this.dismiss.visible=true;
    },
    dismissDialogConfirm(){
      this.dismiss.visible=false;
      this.dismissConfirm.visible=true;
    },
    dismissDialogClose(){
      this.dismiss.visible=false;
    },
    dismissDialogConfirmClose(){
      this.dismissConfirm.visible=false;
    },
    dismissDialogConfirmConfirm(){
      this.loadData();
      this.dismissConfirm.visible=false;
    },
    loadData() {
      //列表
      var that = this;
      var parameter = {
        mobile: that.input,
        page: that.pagenum,
        pageSize: that.pagesize
      };
      that.api.teamQueryAUTH(parameter).then((response) => {
        response = response.data;
        console.log(response);
        if (response.totalCount > 0) {
          that.total = response.totalCount;
          that.tableData = response.list;
        }
      });
    },
    handleCurrentChange(cpage) {
      //分页
      this.pagenum = cpage;
      this.loadData();
    },
  },
};
</script>
<style lang="less" scoped="scoped">
.content img {
  width: 40px;
}
.search-box {
  display: flex;

}
/deep/.ivu-btn
{
  padding:5px;
}
/deep/.el-table td.el-table__cell div
{
  display: flex;
    align-items: center;
    justify-content:center;
}

/deep/.el-dialog__body
{
background:#f5f7f9;

}
/deep/.ivu-input-search
{
background: #185AD6 !important;
border-radius: 2px;
}

</style>
